<ng-container *ngFor="let form of forms; let i = index; trackBy: formTrackBy">
	<div class="field-wrapper">
		<ie-form-field [label]="'FORM_NAME' | translate">
			<input
			type="text"
				[(ngModel)]="form.name"
				(change)="onFormFieldChanged('name')"
				[name]="'form_' + i + '_name'"
				class="ie-form-field-styling"
			/>
		</ie-form-field>
		<ie-form-field [label]="'SEND_TO_EMAILS' | translate">
			<input
			type="text"
				[(ngModel)]="form.email"
				(change)="onFormFieldChanged('email')"
				[name]="'form_' + i + '_name'"
				class="ie-form-field-styling"
			/>
		</ie-form-field>
		<ie-form-field *ngIf="form?.email" [label]="'EMAIL_FROM' | translate">
			<input
			type="text"
				readonly 
				#formEmailFrom
				(focus)="onFormFieldFocus()"
				[(ngModel)]="form.formEmailFrom"
				(change)="onFormFieldChanged('formEmailFrom')"
				[name]="'form_' + i + '_name'"
				class="ie-form-field-styling"
			/>
		</ie-form-field>
		<ie-form-field [label]="'POST_TO_URL' | translate">
			<input
			type="text"
				[(ngModel)]="form.action"
				(change)="onFormFieldChanged('action')"
				[name]="'form_' + i + '_name'"
				class="ie-form-field-styling"
			/>
		</ie-form-field>
		<ie-form-field [label]="'ALSO_POST_TO_OVP' | translate" [useDataSource]="false">
			<bb-check
				[(ngModel)]="form.alsoPostToServer"
				[name]="'form_' + i + '_name'"
				(onChanged)="onFormFieldChanged('alsoPostToServer')"
				[trueValue]="'true'" [falseValue]="'false'"
			></bb-check>
		</ie-form-field>
		<ie-form-field [label]="'USE_TEMPLATE_URL' | translate">
			<input
			type="text"
				[(ngModel)]="form.formEmailTemplate"
				(change)="onFormFieldChanged('formEmailTemplate')"
				[name]="'form_' + i + '_name'"
				class="ie-form-field-styling"
			/>
		</ie-form-field>

		<div class="form-widgets" *ngIf="!formWidgets?.length">
			<strong>{{ 'NO_FORM_WIDGETS' | translate }}</strong>
		</div>
		<div class="form-widgets" *ngIf="formWidgets?.length">
			<h6>{{ 'FORM_WIDGETS' | translate }}</h6>
			<div class="row-wrapper">
				<div class="header">
					<span>{{ 'LABEL' | translate }}</span>
					<span>{{ 'NAME' | translate }}</span>
				</div>
				<ng-container *ngFor="let widget of formWidgets; let i = index;">
					<div class="widget" (click)="selectWidget(widget)">
						<span class="label">
							<span class="icon" [innerHTML]="widget?.type | widgetIcon"></span>
							{{ widget.label }}
						</span>
						<span class="name">{{ widget.config?.formElementName }}
							<span [hidden]="widget.config?.formElementName">
								<span class="warning-message" [title]="'FORM_FIELDS_NEED_NAME' | translate">
									<i class="fa fa-warning"></i>
								</span>
							</span>
						</span>
					</div>
				</ng-container>
			</div>
		</div>

		<h6>{{ 'FORM_EVENT_HANDLERS' | translate }}</h6>
	</div>
	
	<div class="form-event-handlers">
		<event-handler
			#box
			[stateTrackingUid]="'onAllWidgetsValidated_eventhandler_0'"
			[propertyKey]="'onAllWidgetsValidated'"
			[procedures]="(form.onAllWidgetsValidated !== '') ? form.onAllWidgetsValidated : []" 
			(propertyChanged)="propertyChanged($event)"
			(contextmenu)="onEventHandlerContextMenu($event, 'onAllWidgetsValidated', 0, form.onAllWidgetsValidated)"
			(procedureContextMenu)="onProcedureContextMenu($event.ev, $event.key, $event.index, $event.item)"
			>
		</event-handler>
		<event-handler
			#box
			[stateTrackingUid]="'onFailure_eventhandler_1'"
			[propertyKey]="'onFailure'"
			[procedures]="(form.onFailure !== '') ? form.onFailure : []" 
			(propertyChanged)="propertyChanged($event)"
			(contextmenu)="onEventHandlerContextMenu($event, 'onFailure', 1, form.onFailure)"
			(procedureContextMenu)="onProcedureContextMenu($event.ev, $event.key, $event.index, $event.item)">
		</event-handler>
		<event-handler
			#box
			[stateTrackingUid]="'onSuccess_eventhandler_2'"
			[propertyKey]="'onSuccess'"
			[procedures]="(form.onSuccess !== '') ? form.onSuccess : []" 
			(propertyChanged)="propertyChanged($event)"
			(contextmenu)="onEventHandlerContextMenu($event, 'onSuccess', 2, form.onSuccess)"
			(procedureContextMenu)="onProcedureContextMenu($event.ev, $event.key, $event.index, $event.item)">
		</event-handler>
	</div>
</ng-container>
